import $api from "@/frontend/shared/api/axios";

export type TNoteResponse = {
  content: string;
  section: string;
  createdAt: string;
  createdBy: {
    profileImageUrl: number;
    firstName: string;
    lastName: string;
  };
};

export async function getCompanyListNotes({
  organizationId,
  portfolioCompanyId
}: {
  organizationId: number;
  portfolioCompanyId: number;
}): Promise<TNoteResponse[]> {
  const response = await $api.get(
    `/experts/organizations/${organizationId}/portfolio-companies/${portfolioCompanyId}/notes`
  );
  return response.data.data;
}
